import axios from 'axios'
import { API_URL } from 'utils/constants'

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    'content-type': 'application/json'
  }
})

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return {
        status: response.status,
        data: response.data,
        total: response.headers['content-range']
      }
    }
    return response
  },
  (error) => {
    // Handle errors
    throw error
  }
)

export default axiosClient
